import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { hasPermission } from '../../pages/Login/authUtils';
import Navbar from '../../components/NavBar/NavBar';
import { getStoredData } from '../../json/fecthData';

const PermissionRoute = ({ children, permission, isPublic = false, dynamic = false }) => {
  const isAuthenticated = localStorage.getItem('authenticated') === 'true';
  const { key } = useParams(); // Needed for dynamic route like /dynamic/:key

  // 🟡 Public routes (e.g., login)
  if (isPublic) {
    return isAuthenticated ? <Navigate to="/" /> : children;
  }

  // 🔐 Block if not logged in
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // 🛡️ Static permission check
  if (permission && !hasPermission(permission, `Route for "${permission}"`)) {
    return <Navigate to="/" />;
  }

  // 🛡️ Dynamic permission check (e.g., /dynamic/user → needs user:view)
  if (dynamic && key) {
    const config = getStoredData()?.[3]?.[key]; // e.g., { PermissionPrefix: "user" }
    const prefix = config?.PermissionPrefix || key;
    const dynamicPermission = `${prefix}:view`;

    if (!hasPermission(dynamicPermission, `Dynamic route for "${dynamicPermission}"`)) {
      return <Navigate to="/" />;
    }
  }

  return (
    <>
      <Navbar />
      {children}
    </>
  );
};

export default PermissionRoute;
